// extracted by mini-css-extract-plugin
export var actions = "_sz-4";
export var item = "_sz-1";
export var price = "_sz-3";
export var quantity = "_sz-2";
export var table = "_sz-0";